/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Undertraining_DetrainingInputs */

const en_coach_undertraining_detraining = /** @type {(inputs: Coach_Undertraining_DetrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your fitness is declining and your recent training load is well below your long-term average. You are at risk of deconditioning. Gradually ramp volume back up to arrest the fitness loss.`)
};

const de_coach_undertraining_detraining = /** @type {(inputs: Coach_Undertraining_DetrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Fitness sinkt, und du trainierst deutlich unter deinem Langzeitschnitt. Es droht Dekonditionierung. Steigere den Umfang Schritt für Schritt, um den Abwärtstrend zu stoppen.`)
};

/**
* | output |
* | --- |
* | "Your fitness is declining and your recent training load is well below your long-term average. You are at risk of deconditioning. Gradually ramp volume back u..." |
*
* @param {Coach_Undertraining_DetrainingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_undertraining_detraining = /** @type {((inputs?: Coach_Undertraining_DetrainingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Undertraining_DetrainingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_undertraining_detraining(inputs)
	return de_coach_undertraining_detraining(inputs)
});